import { useEffect, useState } from 'react';
import useFiltersState from '../../../../../state/useFiltersState';
import ModuleFilters, { TgetFiltersList } from '../../../../../components/ModuleFilters/ModuleFilters';
import { getListingFilters } from '../../../../../services/bussines';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import { LoadingOutlined } from '@ant-design/icons';
import { ID_PAYMENT_AGREEMENT, IFilterValues } from '../../../../../types/bussines';

import './BussinesFilters.scss';

const BussinesFilters = () => {
  const { bussinesFilters, setBussinesFilters } = useFiltersState();
  const [loading, setLoading] = useState<boolean>(false);
  const [kamOpions, setKamOptions] = useState<IFilterValues[]>([]);
  const [paymentAgreementOptions, setPaymentAgreementOptions] = useState<IFilterValues[]>([]);
  const [clientOpions, setClientOptions] = useState<IFilterValues[]>([]);
  const [tagOpions, setTagOptions] = useState<IFilterValues[]>([]);

  const [openTypeOfClientFilter, setOpenTypeOfClientFilter] = useState<boolean>(false);
  const [openTagsFilter, setOpenTagsFilter] = useState<boolean>(false);
  const [openKamFilter, setOpenKamFilter] = useState<boolean>(false);
  const [openPaymentAgreementFilter, setOpenPaymentAgreementFilter] = useState<boolean>(false);

  const kamFilterRawOptions = kamOpions.map(item => (item?.name !== ' ' ? item?.name : item?.email || ''));
  const paymentAgreementFilterRawOptions = paymentAgreementOptions.map(item => item.name);
  const tagFilterRawOptions = tagOpions.map(item => item.name);
  const clientFilterRawOptions = clientOpions.map(item => item.name);

  const kamNameToCodeMap: Map<string, string> = new Map(
    kamOpions?.map(type => [type?.name !== ' ' ? type?.name : type?.email || '', String(type.id)])
  );
  const paymentAgreementNameToCodeMap: Map<string, string> = new Map(
    paymentAgreementOptions?.map(type => [type.name, String(type.id)])
  );
  const tagNameToCodeMap: Map<string, string> = new Map(tagOpions?.map(type => [type.name, String(type.id)]));

  const clientNameToCodeMap: Map<string, string> = new Map(clientOpions?.map(type => [type.name, String(type.id)]));

  const bussinesFilterMapping = {
    client: 'client',
    tag: 'tag',
    kam: 'kam',
    commercialPreferenceType: 'commercialPreferenceType'
  };
  const getBussinesFiltersList: TgetFiltersList = (
    formModuleFilters,
    handleClickFilterOption,
    getFilterActiveStatus
  ) => [
    {
      title: 'Cliente',
      openFunction: setOpenTypeOfClientFilter,
      openStatus: openTypeOfClientFilter,
      rawSelectOptions: formModuleFilters('client', clientFilterRawOptions, clientNameToCodeMap),
      handleChangeSelectedOption: handleClickFilterOption('client', 'value'),
      isFilterActive: getFilterActiveStatus('client')
    },
    {
      title: 'Etiquetas',
      openFunction: setOpenTagsFilter,
      openStatus: openTagsFilter,
      rawSelectOptions: formModuleFilters('tag', tagFilterRawOptions, tagNameToCodeMap),
      handleChangeSelectedOption: handleClickFilterOption('tag', 'value'),
      isFilterActive: getFilterActiveStatus('tag'),
      conditionedFilter: true,
      filterUnlocked: tagFilterRawOptions?.length > 0
    },
    {
      title: 'KAM',
      openFunction: setOpenKamFilter,
      openStatus: openKamFilter,
      rawSelectOptions: formModuleFilters('kam', kamFilterRawOptions, kamNameToCodeMap),
      handleChangeSelectedOption: handleClickFilterOption('kam', 'value'),
      isFilterActive: getFilterActiveStatus('kam')
    },
    {
      title: 'Acuerdo de pago',
      openFunction: setOpenPaymentAgreementFilter,
      openStatus: openPaymentAgreementFilter,
      rawSelectOptions: formModuleFilters(
        'commercialPreferenceType',
        paymentAgreementFilterRawOptions,
        paymentAgreementNameToCodeMap
      ),
      handleChangeSelectedOption: handleClickFilterOption('commercialPreferenceType', 'value'),
      isFilterActive: getFilterActiveStatus('commercialPreferenceType')
    }
  ];

  const getFiltersData = async () => {
    setLoading(true);
    try {
      const data = await getListingFilters();
      const dataFilterPaymentAgreement = data?.commercialPreferenceTypeFilterValues
        .filter(
          item =>
            item.id === ID_PAYMENT_AGREEMENT.REQUIRE_PAYMENT_AGREEMENT_FOR_ORDER ||
            item.id === ID_PAYMENT_AGREEMENT.REQUIRE_PAYMENT_AGREEMENT_FOR_SERVICE
        )
        .map(item => ({
          ...item,
          name: item.id === ID_PAYMENT_AGREEMENT.REQUIRE_PAYMENT_AGREEMENT_FOR_ORDER ? 'Órdenes' : 'Servicios'
        }));
      if (dataFilterPaymentAgreement) setPaymentAgreementOptions(dataFilterPaymentAgreement);
      if (data?.clientFilterValues) setClientOptions(data?.clientFilterValues || []);
      if (data?.kamFilterValues) setKamOptions(data?.kamFilterValues || []);
      if (data?.tagFilterValues) setTagOptions(data?.tagFilterValues || []);
    } catch {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFiltersData();
  }, []);

  return (
    <div className="bussinesFilters" style={{ justifyContent: loading ? 'center' : '' }}>
      {loading ? (
        <LoadingOutlined style={{ color: '#070F21', fontSize: '20px' }} />
      ) : (
        <ModuleFilters
          moduleFilters={bussinesFilters}
          setModuleFilters={setBussinesFilters}
          getFiltersList={getBussinesFiltersList}
          moduleFiltersTitlesMapping={bussinesFilterMapping}
          customGap={80}
          moduleFiltersIconContainerCustomClass="moduleFiltersIconContainerCustomClass"
          optionTextCustomClass="optionTextCustomClassBussines"
        />
      )}
    </div>
  );
};

export default BussinesFilters;
